module.exports = __webpack_public_path__ + "img/22_78.ef0c65a4.png";